import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, PATCH, POST, PUT } from "../../services/axiosInstance";
import { route } from "../../services/apiRoutes";
import { FORM_PHASE } from "../../config/constant";

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  error: null,
  activeStep: 0, // while reseting set null
  applicantActiveStep: 0,
  kycVerificationActiveStep: 0,
  applicantTotal: 0,
  createBookingData: {},
  enquiryDetails: {},
  applicantData: {},
  applicantPdf: {},
  termsAndCondition: {},
  masterData: {},
  showUploadProfileImage: false,
  showUploadPanImage: false,
  showUploadPassportImage: false,
  showUploadOCIImage: false,
  showUploadOCIAlternateImage: false,
  showUploadAadharImage: false,
  referralList: [],
  reviewActiveStep: 0,
  showReferralModal: false,
  showMobileStepper: false,
  isAgreedOnTerms: false,
  isFromPreview: { value: false, index: null },
  stepsCompleted: {},
  showPhysicalProfileImage: false,
  showPhysicalPanImage: false,
  showPhysicalPassportImage: false,
  showPhysicalOCIImage: false,
  showPhysicalOCIAlternateImage: false,
  showPhysicalAadharImage: false,
  projectBrandImage: "",
  partnerHeaderImage: "",
  applicantEditPreview: false,
  checkFirstStepCompleted: false,
  applicantActiveStep1: 0,
  applicantActiveStep2: 0,
  referralDetails: {},
  eSignature: false,
  offline: false,
  EOIBooking: false,
  stepEOI: 0,
  showUploadPaymentProofImage: false,
  bookingDocuments: {},
  showUploadGSTCertificate: false,
  showChequeImage: false,
  showTransactionScreenshot: false,
  showThankYouMessage: false,
  isUpgradePreferentialStep:false,
  /** True when user opened the form from thank-you "View & Edit" — keeps unit-pref voucher column visible despite paidVoucherId until payment is updated. */
  unitPrefEditFromThankYou: false,
  totalAmountPayable:200000,
  eoiCampaignDetails: {},
  myVoucherList:[],
  shouldVerifyDigilockerOnReturn: false,
  hasContinuedAsMinor: false,
  showSaveAndPreview: false,
  hasContinuedAsMinorModal: false,
};

export const getVoucherById = createAsyncThunk(
  "voucherForm",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.GET_VOUCHER_BY_VOUCHER_ID, payload);
      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {
         return {};
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getApplicantPdf = createAsyncThunk(
  "applicantPdf",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.GET_BOOKING_PDF, payload);
      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

// export const createBooking = createAsyncThunk(
//   "createBooking",
//   async (payload, thunkAPI) => {
//     try {
//       const res = await POST(route.CREATE_BOOKING_API, payload);
//       if (res?.response?.success) {
//         thunkAPI.dispatch(setActiveStep(0));
//         thunkAPI.dispatch(getVoucherById(`/${payload?.opportunityId}`))
//         return res?.response?.response?.data || {};
//       } else {

//       }
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error?.response?.data);
//     }
//   }
// );

// export const getOppprtunityDetails = createAsyncThunk(
//   "enquiryDetails",
//   async (payload, thunkAPI) => {
//     try {
//       const res = await GET(route.GET_OPPORTUNITY_DETAILS, payload);
//       if (res?.response?.success) {
//         return res?.response?.response || {};
//       } else {

//       }
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error?.response?.data);
//     }
//   }
// );

export const getReferralDetails = createAsyncThunk(
  "referralDetails",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.REFERRAL_DETAILS, payload);
      if (res?.response.success) {
        return res?.response?.response?.data || {};
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateApplicantDetails = createAsyncThunk(
  "updateApplicantData",
  async (value, thunkAPI) => {
    try {
      const res = await PATCH(value?.path, value?.payload)
      if(res?.status === 200) {
        let state = thunkAPI.getState()
        let completedSteps = {
          ...state.stepsCompleted,
          [state?.voucherForm?.activeStep]: true,
        };
        thunkAPI.dispatch(setStepsCompleted(completedSteps));
        if (!value?.freezeCurrentStep) {
          thunkAPI.dispatch(setActiveStep(state?.voucherForm?.activeStep + 1));
        }     
        thunkAPI.dispatch(getVoucherById(`/${value?.opportunityId}`))
        return res?.response

      } 
      if(res?.status === 400 || res?.status === 404 || res?.status === 500) {
        console.log('error', res)
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateDocumentCommentDetails = createAsyncThunk(
  "updateDocumentCommentDetails",
  async (value, thunkAPI) => {
    try {
      const res = await PATCH(value?.path, value?.payload);
      if (res?.status === 200) {
        let state = thunkAPI.getState();
        let completedSteps = {
          ...state.stepsCompleted,
          [state?.voucherForm?.activeStep]: true,
        }
        thunkAPI.dispatch(setStepsCompleted(completedSteps))
          thunkAPI.dispatch(setActiveStep(state?.voucherForm?.activeStep + 1));
        thunkAPI.dispatch(getVoucherById(`/${value?.opportunityId}`))
        return res?.response

      } 
      if(res?.status === 400 || res?.status === 404 || res?.status === 500) {
        console.log('error', res)
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);
export const updateOtherDetails = createAsyncThunk(
  "updateOtherDetails",
  async (value, thunkAPI) => {
    try {
      const res = await PATCH(value?.path, value?.payload);
      if (res?.status === 200) {
        let state = thunkAPI.getState();
        let completedSteps = {
          ...state.stepsCompleted,
          [state?.voucherForm?.activeStep]: true,
        };
        thunkAPI.dispatch(setStepsCompleted(completedSteps));
        thunkAPI.dispatch(setActiveStep(state?.voucherForm?.activeStep + 1));

        thunkAPI.dispatch(getVoucherById(`/${value?.opportunityId}`))
        return res?.response
      } 
      if(res?.status === 400 || res?.status === 404 || res?.status === 500) {
        console.log('error', res)
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);
// funtion for applicant 1 to 4 steps
export const updateApplicantDetailsForm = createAsyncThunk(
  "updateApplicantDetailsForm",
  async (value, thunkAPI) => {
    try {
      const res = await PATCH(value?.path, value?.payload);
      if (res?.status === 200) {
        let state = thunkAPI.getState();

        thunkAPI.dispatch(
          setApplicantActiveStep(state?.voucherForm?.applicantActiveStep + 1)
        );
        thunkAPI.dispatch(
          getVoucherById(`/${value?.opportunityId}`)
        );
        return res;
      }
      if (res?.status === 400 || res?.status === 404 || res?.status === 500) {
        console.log("error", res);
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

// function for deleting applicant
export const deleteApplicantDetailsForm = createAsyncThunk(
  "deleteApplicantDetailsForm",
  async (value, thunkAPI) => {   
    try {
      const res = await PATCH(`${route.DELETE_VOUCHER_APPLICANT}/${value?.voucherId}`, {
        applicantNumber: value?.applicantNo
      });
      if (res?.status === 200) {
        // Immediately update applicant total
        const currentState = thunkAPI.getState();
        const newApplicantTotal = Math.max(1, currentState.voucherForm.applicantTotal - 1);
        thunkAPI.dispatch(setApplicantTotal(newApplicantTotal));
        
        // Clean up stepsCompleted for steps that no longer exist immediately
        const newStepsCompleted = {};
        Object.keys(currentState.voucherForm.stepsCompleted).forEach(stepKey => {
          const stepNumber = Number.parseInt(stepKey);
          if (stepNumber < newApplicantTotal + 3) { // +3 for unit preference, review, payment
            newStepsCompleted[stepKey] = currentState.voucherForm.stepsCompleted[stepKey];
          }
        });
        thunkAPI.dispatch(setStepsCompleted(newStepsCompleted));
        
        const updatedData = await thunkAPI.dispatch(
          getVoucherById(`/${value?.voucherId}`)
        ).unwrap();
        
        // Redirect to previous step after successful deletion
        thunkAPI.dispatch(setActiveStep(value?.previousStep || 0));
        
        return { ...res, data: updatedData };
      }
      if (res?.status === 400 || res?.status === 404 || res?.status === 500) {
        console.log("error", res);
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const createReferrals = createAsyncThunk(
  "createReferrals",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.CREATE_REFERRALS, payload);
      if (res?.status === 201) {
        return res.response;
      }
      if (res?.status === 400 || res?.status === 404 || res?.status === 500) {
        console.log("error", res);
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getTermsAndCondition = createAsyncThunk(
  "termsAndCondition",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.GET_TERMS_AND_CONDITION, payload);
      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getMasterDataList = createAsyncThunk(
  "getMasterDataList",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.GET_MASTER_DATA, payload);  
      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateReviewDetails = createAsyncThunk(
  "updateReviewDetails",
  async (value, thunkAPI) => {
    try {
      const res = await PATCH(value?.path, value?.payload);
      if (res?.status === 200) {
        let state = thunkAPI.getState();

        if(value?.stepsLenght === 3) {
        thunkAPI.dispatch(
          setReviewActiveStep(state?.voucherForm?.reviewActiveStep + 1)
        );
        thunkAPI.dispatch(
          getVoucherById(`/${value?.opportunityId}`)
        );
        } else{
     let completedSteps = {
          ...state.stepsCompleted,
          [state?.voucherForm?.activeStep]: true,
        }
        thunkAPI.dispatch(setStepsCompleted(completedSteps))
        if (!value?.freezeCurrentStep) {        
          thunkAPI.dispatch(setActiveStep(state?.voucherForm?.activeStep + 1));
        }     
        thunkAPI.dispatch(getVoucherById(`/${value?.opportunityId}`))
        }
       
        return res?.response;
      } else {
        if (res?.status === 400 || res?.status === 404 || res?.status === 500) {
          console.log("error", res);
        }
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateSaveForLaterVoucherForm = createAsyncThunk(
  "updateSaveForLater",
  async (value, thunkAPI) => {
    try {
       const { path, payload, voucherId, method = "PATCH" } = value;
   let res;

      if (method === "POST") {
        res = await POST(path, payload);
      } else {
        res = await PATCH(path, payload);
      }
      if (res?.status === 200) {
        thunkAPI.dispatch(
          getVoucherById(`/${voucherId}`)
        );
        return res?.response;
      } else {
        if (res?.status === 400 || res?.status === 404 || res?.status === 500) {
          console.log("error", res);
        }
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateReviewAndSign = createAsyncThunk(
  "updateReviewAndSign",
  async (value, thunkAPI) => {
    try {
      const res = await PATCH(value?.path,value?.payload)
      if(res?.status === 200) {
        let state = thunkAPI.getState()
        state.isAgreedOnTerms = value?.payload?.isAgreedOnTerms
        thunkAPI.dispatch(getVoucherById(`/${value?.opportunityId}`))
       return res?.response
      } else {
        if (res?.status === 400 || res?.status === 404 || res?.status === 500) {
          console.log("error", res);
        }
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getPresignedUrl = createAsyncThunk(
  "getPresignedUrl",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.GET_PRESIGNED_URL, payload);
      if (res?.response?.success) {
        return res?.response?.response;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const uploadFile = createAsyncThunk(
  "uploadFile",
  async (payload, thunkAPI) => {
    try {
      const res = await PUT(payload.presignedUrl, payload.file, {
        headers: {
          "Content-Type": payload.file.type,
        },
      });
      if (res?.response?.status === 200) {
        return res?.response;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteImage = createAsyncThunk(
  "deleteImage",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.DELETE_IMAGE, payload);
      if (res?.response?.success) {
        return res?.response;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateImageData = createAsyncThunk(
  "updateImageData",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.UPDATE_DELETE_IMAGE, payload)
      if(res?.status === 201) {
        thunkAPI.dispatch(getVoucherById(`/${payload?.oppId}`))
        return res?.response
      } 
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const signForApplicant = createAsyncThunk(
  "signForApplicant",
  async (value, thunkAPI) => {
    try {
      const res = await POST(value?.path, value?.payload);
      // if(res?.status === 200 || res?.status === 201) {
      //  return res?.response
      // } else {
      //   if(res?.status === 400 || res?.status === 404 || res?.status === 500) {
      //     console.log('error', res)
      //   }
      // }
      if (res?.response?.success) {
        return res?.response?.response;
      } else {
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const saveRatingFeedback = createAsyncThunk(
  "saveRatingFeedback",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.SAVE_RATING_FEEDBACK, payload);
      if (res?.response?.success) {
        return res?.response?.response;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);
export const deleteBooking = createAsyncThunk(
  "deleteBooking",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.DELETE_BOOKING, payload);
      if (res?.response?.success) {
        return res?.response?.response;
      }
      return thunkAPI.rejectWithValue(res?.response ?? { message: "Delete booking failed" });
    } catch (error) {
      const data = error?.response?.data;
      if (data != null && data !== "") {
        return thunkAPI.rejectWithValue(data);
      }
      return thunkAPI.rejectWithValue({
        message: error?.message || "Request failed",
      });
    }
  }
);

export const getBookingDocuments = createAsyncThunk(
  "getBookingDocuments",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.GET_BOOKING_DOCUMENTS, payload);
      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);
export const updateReferralDetails = createAsyncThunk(
  "updateReferralData",
  async (value, thunkAPI) => {
    try {
      const res = await POST(value?.path, value?.payload);
      if (res?.status === 200) {
        let state = thunkAPI.getState();
        let completedSteps = {
          ...state.stepsCompleted,
          [state?.voucherForm?.activeStep]: true,
        }
        thunkAPI.dispatch(setStepsCompleted(completedSteps))
        thunkAPI.dispatch(getVoucherById(`/${value?.opportunityId}`))
        return res?.response?.response
      } 
      if(res?.status === 400 || res?.status === 404 || res?.status === 500) {
        console.log('error', res)
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

//Payment
export const createRazorpayOrder = createAsyncThunk(
  "payments/createOrder",
  async (payload, thunkAPI) => {
    try {
      // payload = { amount, receipt, entityType, entityId }
      const res = await POST(route.CREATE_RAZORPAY_ORDER, payload);

      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {
        return thunkAPI.rejectWithValue(
          res?.response?.message || "Order creation failed"
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data || "Something went wrong"
      );
    }
  }
);

// thunk for voucher payment update
export const updateVoucherPaymentData = createAsyncThunk(
  "voucher/updatePaymentData",
  async (value, thunkAPI) => {
    try {
      const res = await PATCH(value?.path, value?.payload);

      if (res?.status === 200) {
        // refresh the updated voucher
        thunkAPI.dispatch(getVoucherById(`/${value?.opportunityId}`));
        return res;
      }

      // handle common error codes
      if ([400, 404, 500].includes(res?.status)) {
        console.error("Voucher Payment Update Error:", res);
        return thunkAPI.rejectWithValue(res);
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const verifyVoucherPayment = createAsyncThunk(
  "payments/verify",
  async (payload, thunkAPI) => {
    try {
      // payload = { razorpayPaymentId, razorpayOrderId, razorpaySignature, entityId, entityType }
      const res = await POST(route.VOUCHER_PAYMENT_VERIFY, payload);

      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {
        return thunkAPI.rejectWithValue(
          res?.response?.message || "Payment verification failed"
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data || "Something went wrong during verification"
      );
    }
  }
);

//OTP

export const sendVoucherOTP = createAsyncThunk(
  "vouchers/sendOTP",
  async (payload, thunkAPI) => {
    try {
      // payload = { voucherId: "VID-26074639" }
      const res = await POST(route.SEND_OTP, payload);

      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {
        return thunkAPI.rejectWithValue(
          res?.response?.message || "Failed to send OTP"
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data || "Something went wrong while sending OTP"
      );
    }
  }
);

export const reSendVoucherOTP = createAsyncThunk(
  "vouchers/resendOTP",
  async (payload, thunkAPI) => {
    try {
      // payload = { voucherId: "VID-26074639" }
      const res = await POST(route.RESEND_OTP, payload);

      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {
        return thunkAPI.rejectWithValue(
          res?.response?.message || "Failed to send OTP"
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data || "Something went wrong while sending OTP"
      );
    }
  }
);

export const enableEditForm = createAsyncThunk(
  "voucher/enableEditForm",
  async (value, thunkAPI) => {
    try {
      const res = await PATCH(value?.path, value?.payload);

      if (res?.status === 200) {
        // refresh the updated voucher
        thunkAPI.dispatch(getVoucherById(`/${value?.opportunityId}`));
        return res;
      }

      // handle common error codes
      if ([400, 404, 500].includes(res?.status)) {
        console.error("Voucher Payment Update Error:", res);
        return thunkAPI.rejectWithValue(res);
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || error.message);
    }
  }
);

export const VerifyOTP = createAsyncThunk(
  "vouchers/verifyOTP",
  async (payload, thunkAPI) => {
    try {
      // payload = { amount, receipt, entityType, entityId }
            const res = await POST(route.VERIFY_OTP, payload);


      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {
        return thunkAPI.rejectWithValue(
          res?.response?.message 
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data ||  "Something went wrong while verifying OTP"
      );
    }
  }
);

export const BuyNewVoucher = createAsyncThunk(
  "vouchers/verifyOTP",
  async (payload, thunkAPI) => {
    try {
      // payload = { amount, receipt, entityType, entityId }
            const res = await POST(route.BUY_NEW_VOUCHER, payload);


      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {
        return thunkAPI.rejectWithValue(
          res?.response?.message 
        );
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data ||  "Something went wrong while verifying OTP"
      );
    }
  }
);

export const deletePaymentDetails = createAsyncThunk(
  "deletePaymentDetails",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.DELETE_TRANSACTIONS, payload);
      if (res?.response?.success) {
        return res?.response;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const sendVoucherFormLink = createAsyncThunk(
  "sendEoiFormLink",
  async (id, thunkAPI) => {
    try {
      const res = await GET(`${route.SEND_EOI_FORM_LINK}${id}`);

      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {
        return thunkAPI.rejectWithValue({
          message: res?.response?.message || "Failed to send EOI form link",
        });
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error?.response?.data || { message: "Something went wrong" }
      );
    }
  }
);


export const getEOICampaignDetails = createAsyncThunk(
  "eoiCampaign/getDetails",
  async (payload, thunkAPI) => {
    try {
      // Assuming the campaign ID is passed as part of payload
      const campaignId = payload?.campaignId || 28; // default 28 if not provided
      const res = await GET(`${route.GET_EOI_CAMPAIGN_DETAILS}/${campaignId}`);

      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {
        return {};
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const requestCancellations = createAsyncThunk(
  "requestCancellations",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.REQUEST_CANCELLATIONS, payload);
      if (res?.response?.success) {
        return res?.response;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getMyVoucherList = createAsyncThunk(
  "getMyVoucherList/list",
  async (payload, thunkAPI) => {
    try {
      // Assuming the campaign ID is passed as part of payload
      const voucherId = payload?.voucherId || 28; // default 28 if not provided
      const res = await GET(`${route.GET_MY_VOUCHER_LIST}/${voucherId}`);

      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {
        return {};
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const eoiExportAsPDF = createAsyncThunk(
  "eoiExportAsPDF", async (voucherId, thunkAPI) => {
    try {
      const s3BaseUrl = process.env.REACT_APP_S3_BASE_URL;
      const res = await GET(`${route.EOI_EXPORT_AS_PDF}/${voucherId}`);
      if (res?.response?.success) {
        const path = res?.response?.response?.data?.filePath;
        const fileUrl = `${s3BaseUrl}/${path}`;
        const fileResponse = await fetch(fileUrl);
        const blob = await fileResponse.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = blobUrl;
        a.download = path?.split('/').pop() || 'voucher-form.pdf';
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        window.URL.revokeObjectURL(blobUrl);
      } else {
        return thunkAPI.rejectWithValue(
          res?.response?.message || 'Export failed'
        )
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data)
    }
  }
);

export const VoucherFormSlice = createSlice({
  name: "voucherForm",
  initialState,
  reducers: {
    clearState: () => initialState,
    setActiveStep: (state, action) => {
      state.activeStep = action.payload;
    },
    setApplicantActiveStep: (state, action) => {
      state.applicantActiveStep = action.payload;
    },
    setKycVerificationActiveStep: (state, action) => {
      state.kycVerificationActiveStep = action.payload;
    },
    setApplicantTotal: (state, action) => {
      state.applicantTotal = action.payload;
    },
    setShowUploadProfileImage: (state, action) => {
      state.showUploadProfileImage = action.payload;
    },
    setShowUploadPanImage: (state, action) => {
      state.showUploadPanImage = action.payload;
    },
    setShowUploadOCIImage: (state, action) => {
      state.showUploadOCIImage = action.payload;
    },
    setShowUploadOCIAlternateImage: (state, action) => {
      state.showUploadOCIAlternateImage = action.payload;
    },
    setShowUploadPassportImage: (state, action) => {
      state.showUploadPassportImage = action.payload;
    },
    setShowUploadAadharImage: (state, action) => {
      state.showUploadAadharImage = action.payload;
    },
    setReferralList: (state, action) => {
      state.referralList = action.payload;
    },
    setReviewActiveStep: (state, action) => {
      state.reviewActiveStep = action.payload;
    },
    setIsError: (state, action) => {
      state.isError = action.payload;
    },
    setShowMobileStepper: (state, action) => {
      state.showMobileStepper = action.payload;
    },
    setShowReferralModal: (state, action) => {
      state.showReferralModal = action.payload;
    },
    setCheckFirstStepCompleted: (state, action) => {
      state.checkFirstStepCompleted = action.payload;
    },
    setApplicantActiveStep1: (state, action) => {
      state.applicantActiveStep1 = action.payload;
    },
    setApplicantActiveStep2: (state, action) => {
      state.applicantActiveStep2 = action.payload;
    },
    setESignature: (state, action) => {
      state.eSignature = action.payload;
    },
    setOffline: (state, action) => {
      state.offline = action.payload;
    },
    setResetData: (state, action) => {
      state.activeStep = 0
      state.applicantActiveStep = 0
      state.applicantActiveStep1 = 0
      state.applicantActiveStep2 = 0
      state.applicantTotal = 0
      state.reviewActiveStep = 0
      state.applicantData = {}
      state.showReferralModal = false
      state.isError = false
      state.isLoading = false
      state.projectBrandImage = ''
      state.partnerHeaderImage = ''
      state.showUploadProfileImage = false
      state.showUploadPanImage = false
      state.showUploadPassportImage = false
      state.showUploadOCIImage = false
      state.showUploadOCIAlternateImage = false
      state.showUploadAadharImage = false
      state.applicantEditPreview = false
      state.showUploadPaymentProofImage = false
      state.showUploadGSTCertificate = false
      state.showChequeImage = false
      state.showTransactionScreenshot = false
      state.showSaveAndPreview = false;
      state.unitPrefEditFromThankYou = false;
    },
    setUnitPrefEditFromThankYou: (state, action) => {
      state.unitPrefEditFromThankYou = Boolean(action.payload);
    },
    setIsFromPreview: (state, action) => {
      state.isFromPreview = action.payload;
    },
    setStepsCompleted: (state, action) => {
      state.stepsCompleted = action.payload;
    },
    setShowPhysicalProfileImage: (state, action) => {
      state.showPhysicalProfileImage = action.payload;
    },
    setShowPhysicalPanImage: (state, action) => {
      state.showPhysicalPanImage = action.payload;
    },
    setShowPhysicalOCIImage: (state, action) => {
      state.showPhysicalOCIImage = action.payload;
    },
    setShowPhysicalOCIAlternateImage: (state, action) => {
      state.showPhysicalOCIAlternateImage = action.payload;
    },
    setShowPhysicalPassportImage: (state, action) => {
      state.showPhysicalPassportImage = action.payload;
    },
    setShowPhysicalAadharImage: (state, action) => {
      state.showPhysicalAadharImage = action.payload;
    },
    setProjectBrandImage: (state, action) => {
      state.projectBrandImage = action.payload;
    },
    setPartnerHeaderImage: (state, action) => {
      state.partnerHeaderImage = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setEditPreviewApplicant: (state, action) => {
      state.applicantEditPreview = action.payload;
    },
    setShowSaveAndPreview: (state, action) => {
      state.showSaveAndPreview = action.payload;
    },
    setEOIBooking: (state, action) => {
      state.EOIBooking = action.payload;
    },
    setStepEOI: (state, action) => {
      state.stepEOI = action.payload;
    },
    setShowUploadPaymentProofImage: (state, action) => {
      state.showUploadPaymentProofImage = action.payload;
    },
    setShowUploadGSTCertificate: (state, action) => {
      state.showUploadGSTCertificate = action.payload;
    },
    setShowChequeImage: (state, action) => {
      state.showChequeImage = action.payload;
    },
    setShowTransactionScreenshot: (state, action) => {
      state.showTransactionScreenshot = action.payload;
    },
    setShowThankYouMessage:(state, action) =>{
      state.showThankYouMessage = action.payload
    },
     setisUpgradePreferentialStep:(state, action) =>{
      state.isUpgradePreferentialStep = action.payload
    }, 
    setHasContinuedAsMinor: (state, action) => {
      state.hasContinuedAsMinor = action?.payload;
    },
    setHasContinuedAsMinorModal: (state, action) => {
      state.hasContinuedAsMinorModal = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getVoucherById.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getVoucherById.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
      state.applicantData = action?.payload;
      state.isUpgradePreferentialStep =
        action?.payload?.formPhase === FORM_PHASE.EOI &&
        action?.payload?.isUpgradableToEOI === true;
    });
    builder.addCase(getVoucherById.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
      state.applicantData = {};
      state.isUpgradePreferentialStep = false;
    });
    builder.addCase(getApplicantPdf.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getApplicantPdf.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
      state.applicantPdf = action.payload;
    });
    builder.addCase(getApplicantPdf.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(getReferralDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getReferralDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
      state.referralDetails = action.payload;
    });
    builder.addCase(getReferralDetails.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(updateApplicantDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateApplicantDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
    });
    builder.addCase(updateApplicantDetails.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });

    builder.addCase(createReferrals.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(createReferrals.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
    });
    builder.addCase(createReferrals.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(getTermsAndCondition.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getTermsAndCondition.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
      state.termsAndCondition = action.payload;
      const terms = action.payload || {};
      state.partnerHeaderImage = terms.jvPartnerLogo || "";
    });
    builder.addCase(getTermsAndCondition.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
      state.partnerHeaderImage = "";
    });
    builder.addCase(getMasterDataList.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getMasterDataList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
      state.masterData = action.payload;
    });
    builder.addCase(getMasterDataList.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action?.payload?.error;
    });
    builder.addCase(updateApplicantDetailsForm.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateApplicantDetailsForm.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
    });
    builder.addCase(updateApplicantDetailsForm.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(deleteApplicantDetailsForm.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteApplicantDetailsForm.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
      
      // Update applicant data from API response
      if (action.payload?.data) {
        state.applicantData = action.payload.data;
        // Update applicant total based on API response
        const newApplicantTotal = action.payload.data.noOfApplicants || state.applicantTotal;
        state.applicantTotal = newApplicantTotal;
        
        // Clean up stepsCompleted for steps that no longer exist
        const newStepsCompleted = {};
        Object.keys(state.stepsCompleted).forEach(stepKey => {
          const stepNumber = Number.parseInt(stepKey);
          // Keep steps that are still valid (within the new applicant total + remaining steps)
          if (stepNumber < newApplicantTotal + 3) { // +3 for unit preference, review, payment
            newStepsCompleted[stepKey] = state.stepsCompleted[stepKey];
          }
        });
        state.stepsCompleted = newStepsCompleted;
      }
      
      // Reset applicant active step
      state.applicantActiveStep = 0;
    });
    builder.addCase(deleteApplicantDetailsForm.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(updateReviewDetails.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateReviewDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
    });
    builder.addCase(updateReviewDetails.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(updateReviewAndSign.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(updateReviewAndSign.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
    });
    builder.addCase(updateReviewAndSign.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(signForApplicant.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(signForApplicant.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
    });
    builder.addCase(signForApplicant.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(saveRatingFeedback.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(saveRatingFeedback.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
    });
    builder.addCase(saveRatingFeedback.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(deleteBooking.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(deleteBooking.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
    });
    builder.addCase(deleteBooking.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload?.error ?? action.payload;
    });
    builder.addCase(getBookingDocuments.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getBookingDocuments.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
      state.bookingDocuments = action.payload;
    });
    builder.addCase(getBookingDocuments.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload.error;
    });
    builder.addCase(getEOICampaignDetails.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getEOICampaignDetails.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
      state.eoiCampaignDetails = action.payload;
    });

    builder.addCase(getEOICampaignDetails.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload?.error || "Failed to fetch EOI campaign details";
    });

     builder.addCase(getMyVoucherList.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getMyVoucherList.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
      state.myVoucherList = action.payload?.vouchers;
    });

    builder.addCase(getMyVoucherList.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action.payload?.error || "Failed to fetch voucher list";
    });
    
  },
});

export const {
  clearState,
  setActiveStep,
  setApplicantActiveStep,
  setApplicantTotal,
  setShowUploadProfileImage,
  setReferralList,
  setReviewActiveStep,
  setIsError,
  setShowMobileStepper,
  setShowReferralModal,
  setResetData,
  setShowUploadAadharImage,
  setShowUploadPanImage,
  setShowUploadPassportImage,
  setShowUploadOCIImage,
  setShowUploadOCIAlternateImage,
  setIsFromPreview,
  setStepsCompleted,
  setShowPhysicalProfileImage,
  setShowPhysicalPanImage,
  setShowPhysicalOCIImage,
  setShowPhysicalOCIAlternateImage,
  setShowPhysicalPassportImage,
  setShowPhysicalAadharImage,
  setProjectBrandImage,
  setPartnerHeaderImage,
  setIsLoading,
  setEditPreviewApplicant,
  setCheckFirstStepCompleted,
  setApplicantActiveStep1,
  setApplicantActiveStep2,
  setESignature,
  setOffline,
  setEOIBooking,
  setStepEOI,
  setShowUploadPaymentProofImage,
  setShowUploadGSTCertificate,
  setShowChequeImage,
  setShowTransactionScreenshot,
  setShowThankYouMessage,
  setisUpgradePreferentialStep,
  setKycVerificationActiveStep,
  setHasContinuedAsMinor,
  setShowSaveAndPreview,
  setHasContinuedAsMinorModal,
  setUnitPrefEditFromThankYou,
} = VoucherFormSlice.actions;
export default VoucherFormSlice.reducer;